import React from "react";
import { Link } from "react-router-dom";
import "./thanks.css";

export default function Thanks() {
  return (
    <div className="page thanks-page">
      <section className="panel thanks-panel">
        <h1>Thanks!</h1>
        <p>Your message went through. We’ll get back to you soon.</p>

        <div className="thanks-actions">
          <Link className="thanks-link" to="/">
            Back to home
          </Link>
          <Link className="thanks-link" to="/contact">
            Send another message
          </Link>
        </div>
      </section>
    </div>
  );
}